import {GenericoTipoEnum} from "../../bibliotecaPjus/enums/enumGenerico.enum";

export enum TipoArquivoPermitido {
  PNG = 'png',
  JPG = 'jpg',
  JPEG = 'jpeg',
  PDF = 'pdf'
}

export class TipoArquivoPermitidoEnum extends GenericoTipoEnum<TipoArquivoPermitido> {
  static readonly PNG = new TipoArquivoPermitidoEnum(TipoArquivoPermitido.PNG, 'PNG');
  static readonly JPG = new TipoArquivoPermitidoEnum(TipoArquivoPermitido.JPG, 'JPG');
  static readonly JPEG = new TipoArquivoPermitidoEnum(TipoArquivoPermitido.JPEG, 'JPEG');
  static readonly PDF = new TipoArquivoPermitidoEnum(TipoArquivoPermitido.PDF, 'PDF');
}
